import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import SearchInContent from '../../../atoms/SearchInContent';
import ArticleModalTtsControlBar from './ArticleModalTtsControlBar';

const ArticleModalActiveBars = ({
  currentMatch,
  isPaused,
  isSearchOpen,
  isSpeaking,
  progress,
  rate,
  searchTerm,
  totalMatches,
  onChangeRate,
  onCloseSearch,
  onNextMatch,
  onPrevMatch,
  onSearchChange,
  onStopSpeech,
  onToggleSpeech
}) => {
  const speechActive = isSpeaking || isPaused;

  if (!isSearchOpen && !speechActive) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        bgcolor: 'background.paper',
        pt: 1,
        pb: 1,
        mb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5
      }}
    >
      {isSearchOpen && (
        <SearchInContent
          isOpen={isSearchOpen}
          onClose={onCloseSearch}
          searchTerm={searchTerm}
          onSearchChange={onSearchChange}
          totalMatches={totalMatches}
          currentMatch={currentMatch}
          onPrevMatch={onPrevMatch}
          onNextMatch={onNextMatch}
        />
      )}

      {speechActive && (
        <ArticleModalTtsControlBar
          isActive={speechActive}
          isPaused={isPaused}
          progress={progress}
          rate={rate}
          onToggle={onToggleSpeech}
          onChangeRate={onChangeRate}
          onStop={onStopSpeech}
        />
      )}
    </Box>
  );
};

ArticleModalActiveBars.propTypes = {
  currentMatch: PropTypes.number.isRequired,
  isPaused: PropTypes.bool.isRequired,
  isSearchOpen: PropTypes.bool.isRequired,
  isSpeaking: PropTypes.bool.isRequired,
  onChangeRate: PropTypes.func.isRequired,
  onCloseSearch: PropTypes.func.isRequired,
  onNextMatch: PropTypes.func.isRequired,
  onPrevMatch: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onStopSpeech: PropTypes.func.isRequired,
  onToggleSpeech: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  totalMatches: PropTypes.number.isRequired
};

export default ArticleModalActiveBars;
